import React, { useState } from 'react'
import { Menu, Transition, Disclosure } from '@headlessui/react'
import { Link, StaticImage } from 'gatsby'
import { ChevronDownIcon } from '@heroicons/react/20/solid'
import ChatButton from "./chatButton"


const MobileNav = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);

  //   // Prevent scrolling when the menu is open
  //   if (!isOpen) {
  //     document.body.style.overflow = ''; // Prevent scrolling on the body
  //   } else {
  //     document.body.style.overflow = ''; // Restore scrolling on the body
  //   }
  // };

  // const handleScroll = (e) => {
  //   // Stop propagation of scroll event when the menu is open
  //   if (isOpen) {
  //     e.stopPropagation();
  //   }
  };


  return (


    <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
    <button className="py-2 px-5 rounded-lg font-inter menu-toggle" onClick={toggleMenu}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-8 h-8 font-bold">
  <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
</svg>

    </button>
    <div className={isOpen ? 'flex flex-col' : 'hidden'} >
    <nav className="top-0 right-0 flex flex-col w-full bg-white font-inter fixed h-full menu overflow-auto">
    
    <div className="flex p-4 border-b w-full">
    <div>  
  <Link to="/"><img
  src="https://wp.surfawhile.com/wp-content/uploads/2023/10/Black.svg"
  alt="SurfaWhile Logo"
  className="w-200 mt-4 ml-2"
  style={{ width: 200 }} // Breedte van de afbeelding
/></Link></div>
    <div className="flex-grow"></div>
    <div>   
    <button className="bg-white text-black py-2 px-5 rounded-lg font-inter font-bold inline right-0 mt-4" onClick={toggleMenu}>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-6 h-6">
  <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
</svg>

    </button>
    </div>
    </div>
        
        <Link to="/surfvakanties" className="menu-item px-4 py-2 hover:bg-stone-100 font-bold font-inter text-lg" onClick={toggleMenu}>Alle Surfvakanties</Link>
        
        
      
      <Disclosure>
      {({ open }) => (
          <>
      <Disclosure.Button className="flex w-full justify-between px-4 py-2 text-left text-lg font-bold text-slate-800 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
  
    <span>Bestemmingen</span>
    <ChevronDownIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-6 w-6 text-slate-900 font-bold`}
                />
                

                  </Disclosure.Button>

      <Disclosure.Panel className="text-slate-900">
        <ul className="my-1 font-inter list-none">
        
        <li className="my-1 font-semibold">
          <Link to="/surfvakanties/frankrijk" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/05/france.png" /> Frankrijk </Link>
          </li>


          {/* <li className="my-1">
          <Link to="/surfvakanties/frankrijk" onClick={toggleMenu}>
          Frankrijk</Link>
          </li> */}

          <li className="my-1 font-semibold">
          <Link to="/surfvakanties/spanje" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/05/spain.png" /> Spanje </Link>
          </li>

{/* <li className="my-1">
          <Link to="/surfvakanties/spanje" onClick={toggleMenu}>
          Spanje</Link>
          </li> */}

          <li className="my-1 font-semibold">
          <Link to="/surfvakanties/portugal" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/05/portugal.png" /> Portugal </Link>
          </li>

{/* <li className="my-1">
          <Link to="/surfvakanties/marokko" onClick={toggleMenu}>
          Marokko</Link>
          </li> */}

          <li className="my-1 font-semibold">
          <Link to="/surfvakanties/marokko" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/morocco-1.png" /> Marokko</Link>
          </li>

          <li className="my-1 font-semibold">
          <Link to="/surfvakanties/zuid-afrika" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/south-africa.png" /> Zuid-Afrika</Link>
          </li>

          {/* <li className="my-1">
          <Link to="/surfvakanties/zuid-afrika" onClick={toggleMenu}>
          Zuid-Afrika</Link>
          </li> */}

          <li className="my-1 font-semibold">
          <Link to="/surfvakanties/mexico" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/flag.png" /> Mexico</Link>
          </li>

{/* <li className="my-1">
          <Link to="/surfvakanties/mexico" onClick={toggleMenu}>
          Mexico</Link>
          </li> */}

          <li className="my-1 font-semibold">
          <Link to="/surfvakanties/nicaragua" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/nicaragua.png" /> Nicaragua</Link>
          </li>


          <li className="my-1 font-semibold">
          <Link to="/surfvakanties/costa-rica" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/costa-rica.png" /> Costa Rica</Link>
          </li>

          {/* <li className="my-1">
          <Link to="/surfvakanties/costa-rica" onClick={toggleMenu}>
          Costa Rica</Link>
          </li> */}

          <li className="my-1 font-semibold">
          <Link to="/surfvakanties/ecuador" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/ecuador.png" /> Ecuador</Link>
          </li>

{/* <li className="my-1">
          <Link to="/surfvakanties/ecuador" onClick={toggleMenu}>
          Ecuador</Link>
          </li> */}

          {/* <li className="my-2">
          <Link to="/surfvakanties/sri-lanka" onClick={toggleMenu}>
          <img className="block w-6 h-6 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/sri-lanka.png" /> Sri Lanka</Link>
          </li> */}

          <li className="my-1 font-semibold">
          <Link to="/surfvakanties/indonesie" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/indonesia.png" /> Indonesië</Link>
          </li>

          {/* <li className="my-1">
          <Link to="/surfvakanties/indonesie" onClick={toggleMenu}>
          Indonesië</Link>
          </li> */}

        </ul>
      </Disclosure.Panel>


      

      
      </>
      )}
    </Disclosure>



    
    
    



    <Disclosure>
      {({ open }) => (
          <>
      <Disclosure.Button className="flex w-full justify-between px-4 py-2 text-left text-lg font-bold text-slate-800 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
  
    <span>Thema's</span>
    <ChevronDownIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-6 w-6 text-slate-900 font-bold`}
                />
                

                  </Disclosure.Button>

      <Disclosure.Panel className="text-slate-900">
        <div className="my-1 font-inter list-none">
        
  <div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/yoga" className="flex" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="h-5 w-5 mx-2 inline">
                <g fill="none" stroke="#78716c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="m14.571 15.004l.858 1.845s3.857.819 3.857 2.767C19.286 21 17.57 21 17.57 21H13l-2.25-1.25"/>
              <path d="m9.429 15.004l-.857 1.845s-3.858.819-3.858 2.767C4.714 21 6.43 21 6.43 21H8.5l2.25-1.25L13.5 18"/><path d="M3 15.926s2.143-.461 3.429-.922C7.714 8.546 11.57 9.007 12 9.007c.429 0 4.286-.461 5.571 5.997c1.286.46 3.429.922 3.429.922M12 7a2 2 0 1 0 0-4a2 2 0 0 0 0 4Z"/></g></svg>
              </div>    
            
            <span className="mt-1 font-semibold">Surf &amp; Yoga </span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/families" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="#78716c" className="w-5 h-5 mx-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
</svg></div>    
<span className="mt-1 font-semibold">Families</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/busreizen" className="flex pt-1" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 inline mx-2">
<path d="M8.5 19V21.2C8.5 21.48 8.5 21.62 8.4455 21.727C8.39757 21.8211 8.32108 21.8976 8.227 21.9455C8.12004 22 7.98003 22 7.7 22H5.8C5.51997 22 5.37996 22 5.273 21.9455C5.17892 21.8976 5.10243 21.8211 5.0545 21.727C5 21.62 5 21.48 5 21.2V19M19 19V21.2C19 21.48 19 21.62 18.9455 21.727C18.8976 21.8211 18.8211 21.8976 18.727 21.9455C18.62 22 18.48 22 18.2 22H16.3C16.02 22 15.88 22 15.773 21.9455C15.6789 21.8976 15.6024 21.8211 15.5545 21.727C15.5 21.62 15.5 21.48 15.5 21.2V19M3 12H21M3 5.5H21M6.5 15.5H8M16 15.5H17.5M7.8 19H16.2C17.8802 19 18.7202 19 19.362 18.673C19.9265 18.3854 20.3854 17.9265 20.673 17.362C21 16.7202 21 15.8802 21 14.2V6.8C21 5.11984 21 4.27976 20.673 3.63803C20.3854 3.07354 19.9265 2.6146 19.362 2.32698C18.7202 2 17.8802 2 16.2 2H7.8C6.11984 2 5.27976 2 4.63803 2.32698C4.07354 2.6146 3.6146 3.07354 3.32698 3.63803C3 4.27976 3 5.11984 3 6.8V14.2C3 15.8802 3 16.7202 3.32698 17.362C3.6146 17.9265 4.07354 18.3854 4.63803 18.673C5.27976 19 6.11984 19 7.8 19Z" stroke="#918F8F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg></div>
<span className="mt-1 font-semibold">Busreizen</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/glamping" className="flex pt-1" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" className="w-5 h-5 mx-2 inline">
                <path fill="#78716c" d="M6.432 1.458a.5.5 0 0 0-.768 0c-.727.873-2.18 1.924-3.017 2.391a.5.5 0 0 0-.252.369l-.658 4.781h-.233a.5.5 0 1 0 0 1h8.993a.5.5 0 1 0 0-1h-.137l-.659-4.781a.5.5 0 0 0-.251-.369c-.837-.467-2.29-1.518-3.018-2.39Zm2.01 7.54c-.806-1.153-1.386-2.294-1.924-4.36a.5.5 0 0 0-.968.001C4.958 6.947 4.263 8.12 3.62 9h-.874l.607-4.403c.778-.464 1.902-1.277 2.695-2.078c.793.801 1.918 1.614 2.696 2.078L9.35 9h-.907Zm-1.2 0h-2.41c.407-.632.818-1.416 1.202-2.504c.354.999.744 1.775 1.206 2.505Z"/></svg>
              </div>
              <span className="mt-1 font-semibold">Glamping</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/surfkampen" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mx-2 inline" width="24" height="24" viewBox="0 0 24 24"><path fill="none" stroke="#78716c" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 20L10 4M5 20l9-16M3 20h18m-9-5l-3 5m3-5l3 5"/></svg>
              </div>    
              <span className="mt-1 font-semibold">Surfkampen</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/surflodges" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#78716c" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mx-2 inline">
                <path d="M9 21.0002V13.6002C9 13.0402 9 12.7601 9.10899 12.5462C9.20487 12.3581 9.35785 12.2051 9.54601 12.1092C9.75992 12.0002 10.0399 12.0002 10.6 12.0002H13.4C13.9601 12.0002 14.2401 12.0002 14.454 12.1092C14.6422 12.2051 14.7951 12.3581 14.891 12.5462C15 12.7601 15 13.0402 15 13.6002V21.0002M11.0177 2.76424L4.23539 8.03937C3.78202 8.39199 3.55534 8.5683 3.39203 8.7891C3.24737 8.98469 3.1396 9.20503 3.07403 9.4393C3 9.70376 3 9.99094 3 10.5653V17.8002C3 18.9203 3 19.4804 3.21799 19.9082C3.40973 20.2845 3.71569 20.5905 4.09202 20.7822C4.51984 21.0002 5.07989 21.0002 6.2 21.0002H17.8C18.9201 21.0002 19.4802 21.0002 19.908 20.7822C20.2843 20.5905 20.5903 20.2845 20.782 19.9082C21 19.4804 21 18.9203 21 17.8002V10.5653C21 9.99094 21 9.70376 20.926 9.4393C20.8604 9.20503 20.7526 8.98469 20.608 8.7891C20.4447 8.5683 20.218 8.39199 19.7646 8.03937L12.9823 2.76424C12.631 2.49099 12.4553 2.35436 12.2613 2.30184C12.0902 2.2555 11.9098 2.2555 11.7387 2.30184C11.5447 2.35436 11.369 2.49099 11.0177 2.76424Z" stroke="#78716c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg></div>
              <span className="mt-1 font-semibold">Surflodges</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/jongeren" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mx-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M22 10.5h-6m-2.25-4.125a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zM4 19.235v-.11a6.375 6.375 0 0112.75 0v.109A12.318 12.318 0 0110.374 21c-2.331 0-4.512-.645-6.374-1.766z" />
</svg>

              </div>
              <span className="mt-1 font-semibold">Juniors (-18)</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/volwassenen" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="w-5 h-5 mx-2 inline">
                <path fill="#78716c" d="M18 14v-3h-3V9h3V6h2v3h3v2h-3v3h-2Zm-9-2q-1.65 0-2.825-1.175T5 8q0-1.65 1.175-2.825T9 4q1.65 0 2.825 1.175T13 8q0 1.65-1.175 2.825T9 12Zm-8 8v-2.8q0-.85.438-1.563T2.6 14.55q1.55-.775 3.15-1.163T9 13q1.65 0 3.25.388t3.15 1.162q.725.375 1.163 1.088T17 17.2V20H1Z"/></svg>
              </div>
              <span className="mt-1 font-semibold">Volwassenen</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/lente" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">

  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 mx-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 15a4.5 4.5 0 004.5 4.5H18a3.75 3.75 0 001.332-7.257 3 3 0 00-3.758-3.848 5.25 5.25 0 00-10.233 2.33A4.502 4.502 0 002.25 15z" />
</svg>
</div>    
<span className="mt-1 font-semibold">Lente</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/zomer" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">

<svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mx-2 inline">
<path d="M12.5 2V4M12.5 20V22M4.5 12H2.5M6.81412 6.31412L5.3999 4.8999M18.1859 6.31412L19.6001 4.8999M6.81412 17.69L5.3999 19.1042M18.1859 17.69L19.6001 19.1042M22.5 12H20.5M17.5 12C17.5 14.7614 15.2614 17 12.5 17C9.73858 17 7.5 14.7614 7.5 12C7.5 9.23858 9.73858 7 12.5 7C15.2614 7 17.5 9.23858 17.5 12Z" stroke="#918F8F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg></div>    
<span className="mt-1 font-semibold">Zomer</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/herfstvakantie" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">

<svg width="24" height="24" viewBox="0 0 24 24" fill="#78716c" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mx-2 inline">
<path d="M22 3.41l-.12-1.26-1.2.4a13.84 13.84 0 01-6.41.64 11.87 11.87 0 00-6.68.9A7.23 7.23 0 003.3 9.5a9 9 0 00.39 4.58 16.6 16.6 0 011.18-2.2 9.85 9.85 0 014.07-3.43 11.16 11.16 0 015.06-1A12.08 12.08 0 009.34 9.2a9.48 9.48 0 00-1.86 1.53 11.38 11.38 0 00-1.39 1.91 16.39 16.39 0 00-1.57 4.54A26.42 26.42 0 004 22h2a30.69 30.69 0 01.59-4.32 9.25 9.25 0 004.52 1.11 11 11 0 004.28-.87C23 14.67 22 3.86 22 3.41z" />
</svg></div>    
<span className="mt-1 font-semibold">Herfstvakantie</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/winter" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">

<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 mx-2 inline">
<path d="M18.0623 8.5L5.93792 15.5M18.0623 8.5L19.1604 4.40192M18.0623 8.5L22.1604 9.59808M5.93792 15.5L1.83984 14.4019M5.93792 15.5L4.83984 19.5981M18.0622 15.4999L5.93784 8.49986M18.0622 15.4999L22.1604 14.4018M18.0622 15.4999L19.1604 19.598M5.93784 8.49986L4.83999 4.40203M5.93784 8.49986L1.83999 9.59819M12.0001 5L12.0001 19M12.0001 5L9.0001 2M12.0001 5L15.0001 2M12.0001 19L9.0001 22M12.0001 19L15.0001 22" stroke="#918F8F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg></div>    
<span className="mt-1 font-semibold">Winter</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/kitesurfen" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">

<svg  version="1.0" xmlns="http://www.w3.org/2000/svg"
width="24" height="24" viewBox="0 0 50.000000 50.000000"
preserveAspectRatio="xMidYMid meet" className="w-5 h-5 mx-2 inline">

<g transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
fill="#78716c" stroke="none">
<path d="M179 469 c-17 -24 -20 -36 -12 -48 8 -12 6 -23 -9 -43 l-19 -28 22 0
c12 0 31 8 41 17 15 13 21 14 31 4 21 -21 -20 -41 -86 -41 -53 0 -57 1 -43 16
31 30 9 84 -34 84 -24 0 -50 -26 -50 -50 0 -21 25 -50 43 -50 6 0 3 -6 -7 -13
-25 -18 -33 -95 -13 -133 8 -16 29 -42 45 -57 26 -25 33 -27 52 -17 l22 12
-21 19 c-12 11 -19 24 -16 29 9 15 65 22 80 10 15 -12 55 -5 55 10 0 16 -57
40 -95 40 -23 0 -35 5 -35 14 0 32 13 46 44 46 17 0 49 11 71 23 32 18 45 21
59 13 19 -12 41 9 79 74 30 50 5 34 -33 -21 -34 -50 -35 -51 -51 -30 -10 12
-24 21 -33 21 -22 0 -20 9 10 53 14 21 23 41 21 44 -3 3 -18 -14 -33 -36 -28
-42 -44 -52 -44 -26 0 8 -9 15 -20 15 -24 0 -25 13 -4 46 25 37 10 40 -17 3z"/>
<path d="M368 216 c-67 -28 -131 -64 -216 -122 -68 -47 -87 -52 -118 -29 -23
17 -34 19 -34 4 0 -5 21 -19 47 -31 57 -25 143 -27 229 -4 84 22 112 20 169
-9 27 -13 51 -22 54 -19 9 9 -40 41 -80 53 l-37 11 48 50 c54 56 67 84 50 105
-17 21 -46 18 -112 -9z"/>
</g>
</svg></div>    
<span className="mt-1 font-semibold">Kitesurfen</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/surfvakanties/digital-nomads" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">

<svg
viewBox="0 0 640 512"
fill="#78716c"
height="1em"
width="1em"
className="w-5 h-5 mx-2 inline"
>
<path d="M128 32c-35.3 0-64 28.7-64 64v256h64V96h384v256h64V96c0-35.3-28.7-64-64-64H128zM19.2 384C8.6 384 0 392.6 0 403.2 0 445.6 34.4 480 76.8 480h486.4c42.4 0 76.8-34.4 76.8-76.8 0-10.6-8.6-19.2-19.2-19.2H19.2z" />
</svg></div>
<span className="mt-1 font-semibold">Digital Nomads</span>
  </Link>

</div>
</div>
     
      </Disclosure.Panel>
  
      </>
      )}
    </Disclosure>


    {/* <Disclosure>
      {({ open }) => (
          <>
      <Disclosure.Button className="flex w-full justify-between px-4 py-2 text-left text-lg font-bold text-slate-800 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
  
    <span>Groepsreizen</span>
    <ChevronUpIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-6 w-6 text-slate-900 font-bold`}
                />
                

                  </Disclosure.Button>


      <Disclosure.Panel className="text-slate-900 overflow-auto">
        <div className="my-1 text-sm font-inter list-none">
        
        <div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/groepsreizen/studenten" className="flex" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" className="h-5 w-5 mx-2 inline">
                <g fill="none" stroke="#78716c" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"><path d="m14.571 15.004l.858 1.845s3.857.819 3.857 2.767C19.286 21 17.57 21 17.57 21H13l-2.25-1.25"/>
              <path d="m9.429 15.004l-.857 1.845s-3.858.819-3.858 2.767C4.714 21 6.43 21 6.43 21H8.5l2.25-1.25L13.5 18"/><path d="M3 15.926s2.143-.461 3.429-.922C7.714 8.546 11.57 9.007 12 9.007c.429 0 4.286-.461 5.571 5.997c1.286.46 3.429.922 3.429.922M12 7a2 2 0 1 0 0-4a2 2 0 0 0 0 4Z"/></g></svg>
              </div>    
            
            <span className="mt-1">Studenten </span>
  </Link>
</div>


<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/groepsreizen/bedrijven" className="flex pt-2" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="#78716c" className="w-5 h-5 mx-2 inline">
  <path strokeLinecap="round" strokeLinejoin="round" d="M15 19.128a9.38 9.38 0 002.625.372 9.337 9.337 0 004.121-.952 4.125 4.125 0 00-7.533-2.493M15 19.128v-.003c0-1.113-.285-2.16-.786-3.07M15 19.128v.106A12.318 12.318 0 018.624 21c-2.331 0-4.512-.645-6.374-1.766l-.001-.109a6.375 6.375 0 0111.964-3.07M12 6.375a3.375 3.375 0 11-6.75 0 3.375 3.375 0 016.75 0zm8.25 2.25a2.625 2.625 0 11-5.25 0 2.625 2.625 0 015.25 0z" />
</svg></div>    
<span className="mt-1">Bedrijven</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/groepsreizen/incentive-reizen" className="flex pt-1" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 inline mx-2">
<path d="M8.5 19V21.2C8.5 21.48 8.5 21.62 8.4455 21.727C8.39757 21.8211 8.32108 21.8976 8.227 21.9455C8.12004 22 7.98003 22 7.7 22H5.8C5.51997 22 5.37996 22 5.273 21.9455C5.17892 21.8976 5.10243 21.8211 5.0545 21.727C5 21.62 5 21.48 5 21.2V19M19 19V21.2C19 21.48 19 21.62 18.9455 21.727C18.8976 21.8211 18.8211 21.8976 18.727 21.9455C18.62 22 18.48 22 18.2 22H16.3C16.02 22 15.88 22 15.773 21.9455C15.6789 21.8976 15.6024 21.8211 15.5545 21.727C15.5 21.62 15.5 21.48 15.5 21.2V19M3 12H21M3 5.5H21M6.5 15.5H8M16 15.5H17.5M7.8 19H16.2C17.8802 19 18.7202 19 19.362 18.673C19.9265 18.3854 20.3854 17.9265 20.673 17.362C21 16.7202 21 15.8802 21 14.2V6.8C21 5.11984 21 4.27976 20.673 3.63803C20.3854 3.07354 19.9265 2.6146 19.362 2.32698C18.7202 2 17.8802 2 16.2 2H7.8C6.11984 2 5.27976 2 4.63803 2.32698C4.07354 2.6146 3.6146 3.07354 3.32698 3.63803C3 4.27976 3 5.11984 3 6.8V14.2C3 15.8802 3 16.7202 3.32698 17.362C3.6146 17.9265 4.07354 18.3854 4.63803 18.673C5.27976 19 6.11984 19 7.8 19Z" stroke="#918F8F" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg></div>
<span className="mt-1">Incentive reizen</span>
  </Link>
</div>

<div className="rounded-md px-1 hover:bg-stone-100 mr-2 flex items-center">
  <Link to="/groepsreizen/onderwijs" className="flex pt-1" onClick={toggleMenu}>
  <div className="rounded-md p-1 bg-stone-100 mr-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" className="w-5 h-5 mx-2 inline">
                <path fill="#78716c" d="M6.432 1.458a.5.5 0 0 0-.768 0c-.727.873-2.18 1.924-3.017 2.391a.5.5 0 0 0-.252.369l-.658 4.781h-.233a.5.5 0 1 0 0 1h8.993a.5.5 0 1 0 0-1h-.137l-.659-4.781a.5.5 0 0 0-.251-.369c-.837-.467-2.29-1.518-3.018-2.39Zm2.01 7.54c-.806-1.153-1.386-2.294-1.924-4.36a.5.5 0 0 0-.968.001C4.958 6.947 4.263 8.12 3.62 9h-.874l.607-4.403c.778-.464 1.902-1.277 2.695-2.078c.793.801 1.918 1.614 2.696 2.078L9.35 9h-.907Zm-1.2 0h-2.41c.407-.632.818-1.416 1.202-2.504c.354.999.744 1.775 1.206 2.505Z"/></svg>
              </div>
              <span className="mt-1">Onderwijs</span>
  </Link>
</div>
</div>

      </Disclosure.Panel>
      
      </>
      )}
    </Disclosure> */}

<Disclosure>
      {({ open }) => (
          <>
      <Disclosure.Button className="flex w-full justify-between px-4 py-2 text-left text-lg font-bold text-slate-800 hover:bg-stone-200 focus:outline-none focus-visible:ring focus-visible:ring-stone-500/75">
  
    <span>Groepsreizen</span>
    <ChevronDownIcon
                  className={`${
                    open ? 'rotate-180 transform' : ''
                  } h-6 w-6 text-slate-900 font-bold`}
                />
                

                  </Disclosure.Button>

      <Disclosure.Panel className="text-slate-900">
        <ul className="my-1 font-inter list-none text-sm">
        
        <li className="my-2 font-semibold">
          <Link to="/groepsreizen/studenten" onClick={toggleMenu}>
          Studenten </Link>
          </li>


          {/* <li className="my-1">
          <Link to="/surfvakanties/frankrijk" onClick={toggleMenu}>
          Frankrijk</Link>
          </li> */}

          <li className="my-2 font-semibold">
          <Link to="/groepsreizen/bedrijven" onClick={toggleMenu}>
           Bedrijven </Link>
          </li>

{/* <li className="my-1">
          <Link to="/surfvakanties/spanje" onClick={toggleMenu}>
          Spanje</Link>
          </li> */}

          <li className="my-2 font-semibold">
          <Link to="/groepsreizen/incentive-reizen" onClick={toggleMenu}>
          Incentive reizen</Link>
          </li>

{/* <li className="my-1">
          <Link to="/surfvakanties/marokko" onClick={toggleMenu}>
          Marokko</Link>
          </li> */}

          <li className="my-2 font-semibold">
          <Link to="/groepsreizen/onderwijs" onClick={toggleMenu}>
          Onderwijs</Link>
          </li>

          {/* <li className="my-1">
          <Link to="/surfvakanties/zuid-afrika" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/south-africa.png" /> Zuid-Afrika</Link>
          </li> */}

          {/* <li className="my-1">
          <Link to="/surfvakanties/zuid-afrika" onClick={toggleMenu}>
          Zuid-Afrika</Link>
          </li> */}

          {/* <li className="my-1">
          <Link to="/surfvakanties/mexico" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/flag.png" /> Mexico</Link>
          </li> */}

{/* <li className="my-1">
          <Link to="/surfvakanties/mexico" onClick={toggleMenu}>
          Mexico</Link>
          </li> */}

          {/* <li className="my-1">
          <Link to="/surfvakanties/nicaragua" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/nicaragua.png" /> Nicaragua</Link>
          </li> */}


          {/* <li className="my-1">
          <Link to="/surfvakanties/costa-rica" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/costa-rica.png" /> Costa Rica</Link>
          </li> */}

          {/* <li className="my-1">
          <Link to="/surfvakanties/costa-rica" onClick={toggleMenu}>
          Costa Rica</Link>
          </li> */}

          {/* <li className="my-1">
          <Link to="/surfvakanties/ecuador" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/ecuador.png" /> Ecuador</Link>
          </li> */}

{/* <li className="my-1">
          <Link to="/surfvakanties/ecuador" onClick={toggleMenu}>
          Ecuador</Link>
          </li> */}

          {/* <li className="my-2">
          <Link to="/surfvakanties/sri-lanka" onClick={toggleMenu}>
          <img className="block w-6 h-6 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/sri-lanka.png" /> Sri Lanka</Link>
          </li> */}

          {/* <li className="my-1">
          <Link to="/surfvakanties/indonesie" onClick={toggleMenu}>
          <img className="block w-5 h-5 mr-2 inline" src="https://wp.surfawhile.com/wp-content/uploads/2023/11/indonesia.png" /> Indonesië</Link>
          </li> */}

          {/* <li className="my-1">
          <Link to="/surfvakanties/indonesie" onClick={toggleMenu}>
          Indonesië</Link>
          </li> */}

        </ul>
      </Disclosure.Panel>


      

      
      </>
      )}
    </Disclosure>
    
   
    <Link to="/surfvakanties/aanbiedingen" className="px-4 py-2 hover:bg-stone-100 font-bold font-inter text-lg" onClick={toggleMenu}>Aanbiedingen</Link>

    <Link to="/surfvakanties/surf-en-taalreizen" className="px-4 py-2 hover:bg-stone-100 font-bold font-inter text-lg" onClick={toggleMenu}>Surf &amp; Taalreizen</Link>
    <Link to="https://shop.surfawhile.com/" className="px-4 py-2 hover:bg-stone-100 font-bold font-inter text-lg" onClick={toggleMenu}>SurfaWhile Webshop</Link>
    {/* <Link to="/persoonlijk-advies" className="px-4 py-2 hover:bg-stone-100 font-bold font-inter text-lg" onClick={toggleMenu}>Persoonlijk advies</Link> */}
    <Link to="/over-ons" className="px-4 py-2 hover:bg-stone-100 font-bold font-inter text-lg" onClick={toggleMenu}>Over Ons</Link>
    <Link to="/contact" className="px-4 py-2 hover:bg-stone-100 font-bold font-inter text-lg" onClick={toggleMenu}>Contact</Link>
    
     
</nav>
    </div>
</div>
  )
}

export default MobileNav